/** Removed aliases never identify an authored client or worker rule. */
export const isRemovedRateAlias = (value: unknown): boolean => String(value ?? '').trim() === 'DR-Half';

export const rateTypeDisplayLabel = (code: unknown, label?: string | null): string => {
  if (isRemovedRateAlias(code)) return 'Rate selection required';
  if (isRemovedRateAlias(label)) return 'Agreement rate (label needs review)';
  return label || String(code ?? '');
};
